<template>
  <form @submit.prevent="submit">
    <va-input
      v-model="form.title"
      label="Название"
      class="mb-3"
      :error="!!errors.title"
      :error-messages="errors.title"
    />
    <div class="mb-3">
      <label class="va-input__label">Код</label>
      <select
        v-model="form.code"
        class="form-control"
        :class="{ 'form-control--error': errors.code }"
      >
        <option v-for="opt in codeOptions" :key="opt.value" :value="opt.value">
          {{ opt.text }}
        </option>
      </select>
      <span v-if="errors.code" class="error-message">{{ errors.code }}</span>
    </div>
    <va-input
      v-model.number="form.price"
      type="number"
      min="0"
      label="Базовая цена"
      class="mb-3"
      :error="!!errors.price"
      :error-messages="errors.price"
    />
    <va-input
      v-model.number="form.free_from_sum"
      type="number"
      min="0"
      label="Бесплатно от суммы (оставьте пустым, если не применяется)"
      class="mb-3"
      placeholder=""
      :error="!!errors.free_from_sum"
      :error-messages="errors.free_from_sum"
    />
    <div class="mb-3">
      <label class="va-input__label">Время от</label>
      <input v-model="form.time_from" type="time" class="form-control" />
    </div>
    <div class="mb-3">
      <label class="va-input__label">Время до</label>
      <input v-model="form.time_to" type="time" class="form-control" />
    </div>
    <va-checkbox v-model="form.is_active" label="Активна" class="mb-4" />
    <div class="d-flex gap-2">
      <va-button type="submit" color="primary">Сохранить</va-button>
      <va-button type="button" @click="$emit('cancel')">Отмена</va-button>
    </div>
  </form>
</template>

<script>
export default {
  name: "DeliveryTypeForm",
  props: {
    initial: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        title: "",
        code: "day",
        price: 0,
        free_from_sum: null,
        time_from: "",
        time_to: "",
        is_active: true,
      },
      errors: {},
      codeOptions: [
        { value: "day", text: "day" },
        { value: "night", text: "night" },
      ],
    };
  },
  watch: {
    initial: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form = {
            title: val.title || "",
            code: val.code || "day",
            price: Number(val.price) || 0,
            free_from_sum:
              val.free_from_sum != null ? Number(val.free_from_sum) : null,
            time_from: this.toTimeInput(val.time_from),
            time_to: this.toTimeInput(val.time_to),
            is_active: !!val.is_active,
          };
        } else {
          this.form = {
            title: "",
            code: "day",
            price: 0,
            free_from_sum: null,
            time_from: "",
            time_to: "",
            is_active: true,
          };
        }
        this.errors = {};
      },
    },
  },
  methods: {
    toTimeInput(v) {
      if (!v) return "";
      const s = String(v);
      if (s.length >= 5) return s.substring(0, 5);
      return s;
    },
    validate() {
      this.errors = {};
      if (!this.form.title || !this.form.title.trim()) {
        this.errors.title = "Обязательное поле";
      }
      if (this.form.price < 0) {
        this.errors.price = "Число не может быть отрицательным";
      }
      if (this.form.free_from_sum != null && this.form.free_from_sum < 0) {
        this.errors.free_from_sum = "Число не может быть отрицательным";
      }
      return Object.keys(this.errors).length === 0;
    },
    submit() {
      if (!this.validate()) return;
      const payload = {
        title: this.form.title.trim(),
        code: this.form.code,
        price: Number(this.form.price) || 0,
        free_from_sum:
          this.form.free_from_sum === "" || this.form.free_from_sum == null
            ? null
            : Number(this.form.free_from_sum),
        time_from: this.form.time_from || null,
        time_to: this.form.time_to || null,
        is_active: this.form.is_active,
      };
      this.$emit("submit", payload);
    },
  },
};
</script>

<style scoped>
.form-control {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.form-control--error {
  border-color: #e34a4a;
}
.error-message {
  color: #e34a4a;
  font-size: 0.875rem;
}
</style>
